import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export const VIEW_NAME = "業種分類";
export interface gyoushuInfo {
  id: number;
  gyoushuCd: string;
  gyoushuNm: string;
  createdDate: string;
  updatedDate: string;
}

export const Prop2LabelMap = {
  id: "ID",
  gyoushuCd: "業種分類コード",
  gyoushuNm: "業種分類名",
  createdDate: "登録日時",
  updatedDate: "更新日時",
};

export const tableConfig: TableHeaderConfig[] = [
  {
    prop: "gyoushuCd",
    label: Prop2LabelMap.gyoushuCd,
    width: ColWidth.md,
  },
  {
    prop: "gyoushuNm",
    label: Prop2LabelMap.gyoushuNm,
    width: ColWidth.xxl,
  },
  {
    prop: "createdDate",
    label: Prop2LabelMap.createdDate,
    width: ColWidth.lg,
  },
  {
    prop: "updatedDate",
    label: Prop2LabelMap.updatedDate,
    width: ColWidth.lg,
  },
];
